export enum PazaakTurnMode {
  PLAYER = 0,
  OPPONENT = 1
}
